import { BrowserRouter } from "react-router-dom";
import Routings from "@/router";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import { setDefaultLocale } from "react-datepicker";

setDefaultLocale("ja");

const App = () => {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routings />
        <ToastContainer />
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
